import {useEffect} from 'react';

import PropTypes from 'prop-types';
import {useLocation} from 'react-router-dom';

export const NEXT_URL_KEY = 'next';

export const useNextUrl = () => {
  const redirect = (secondaryUrl) => {
    const nextUrl = sessionStorage.getItem(NEXT_URL_KEY);
    sessionStorage.removeItem(NEXT_URL_KEY);
    window.location.href = nextUrl || secondaryUrl || '/';
  };

  return {redirect};
};

export default function NextUrlProvider({children}) {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const url = search.get(NEXT_URL_KEY);

  useEffect(() => {
    if (!url) return;
    sessionStorage.setItem(NEXT_URL_KEY, url);
  }, [url]);

  return children;
}

NextUrlProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
